module.exports = __webpack_public_path__ + "assets/img/chat-robot.fcbc5323.png";